import React from 'react';
import { Button, Divider, Dropdown, Form, Grid, Header, Input, Loader, Popup, Segment, Table } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { toast, ToastContainer } from 'react-toastify';
import request from '../../Util/request';
import { HeaderCursor } from '../../../../Professor/ProfessorInputGrades/css';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class CreateCandidatesFromUNSA extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            studentOptions: [],
            committeeOptions: [],
            disableStudentField: true,
            targetStudyProgramOptions: []
        };
        this.handleDateChange = this.handleDateChange.bind(this);
        this.createCandidate = this.createCandidate.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.findStudentByJmbg = this.findStudentByJmbg.bind(this);
        this.clearForm = this.clearForm.bind(this);
    }
    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }
    clearForm() {
        this.setState({
            jmbg: '',
            targetStudyProgram: null,
            student: null,
            applicationDate: new Date(),
            committee: null,
            phoneNumber: '',
            email: '',
            studyType: null,
            targetStudyProgramOptions: []
        });
    }
    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        element[0].childNodes[1].classList.remove('segment');
        axios.get('/study-programs/dto-by-faculty').then((res) => {
            let targetStudyProgramOptions = res.data ? res.data.map(el =>
                ({
                    value: el.studyProgram.id,
                    key: el.studyProgram.id,
                    additional: el.studyProgram.studyProgramStatus ? el.studyProgram.studyProgramStatus._key : el.studyProgram.id,
                    text: el.studyProgram.studyProgramBasic ? el.studyProgram.studyProgramBasic.name + ' | ' + el.studyProgram.name + ' | ' + el.studyCycles[0].displayName + (el.studyProgram.studyProgramBasic.comment ? ' | ' + el.studyProgram.studyProgramBasic.comment : '') : ''
                })).reverse() : res.data;
            this.setState({ targetStudyProgramOptions });
        });
        request.fetchCommitteeOptions().then(committeeOptions => this.setState({ committeeOptions }));
        request.fetchStudyTypeOptions().then(studyTypeOptions => this.setState({ studyTypeOptions }));
    }

    findStudentByJmbg() {
        if (!this.state.jmbg) {
            toast(<FormattedMessage id="common.requiredFields" />);
            if (!this.state.jmbg) { this.setState({ jmbgErr: true }); } else { this.setState({ jmbgErr: false }); }
        } else {
            this.setState({ disableSearchButton: true, disableStudentField: true });

            axios.get(`/students/filter-by-jmbg/${this.state.jmbg}`)
                .then(res => {
                    const students = res.data.map((e) => ({
                        value: {
                            studentStudyProgramId: e.studentStudyProgramId,
                            firstName: e.firstName,
                            lastName: e.lastName,
                            index: e.index,
                            jmbg: e.jmbg,
                            facultyId: e.facultyId,
                            facultyName: e.facultyName
                        },
                        key: e.studentStudyProgramId,
                        text: e.firstName + ' ' + e.lastName + ' | ' + e.jmbg + ' | ' + e.index + ' | ' + e.facultyName + ' | ' + e.studyProgramName
                    }));

                    this.setState({ studentOptions: students, disableSearchButton: false, disableStudentField: false });
                })
                .catch(err => {
                    toast('Trenutno nije moguće izvršiti pretragu studenata!');
                    console.log('Failed to search students.');
                });
        }
    }
    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }
    createCandidate() {
        if (!this.state.student || !this.state.date || !this.state.targetStudyProgram || !this.state.phoneNumber
            || !this.state.committee || !this.state.email || !this.state.studyType) {
            toast(<FormattedMessage id="common.requiredFields" />);
            if (!this.state.student) { this.setState({ studentErr: true }); } else { this.setState({ studentErr: false }); }
            if (!this.state.studyType) { this.setState({ studyTypeErr: true }); } else { this.setState({ studyTypeErr: false }); }
            if (!this.state.date) { this.setState({ dateErr: true }); } else { this.setState({ dateErr: false }); }
            if (!this.state.targetStudyProgram) { this.setState({ targetStudyProgramErr: true }); } else { this.setState({ targetStudyProgramErr: false }); }
            if (!this.state.committee) { this.setState({ committeeErr: true }); } else { this.setState({ committeeErr: false }); }
            if (!this.state.phoneNumber) { this.setState({ phoneNumberErr: true }); } else { this.setState({ phoneNumberErr: false }); }
            if (!this.state.email) { this.setState({ emailErr: true }); } else { this.setState({ emailErr: false }); }
        } else {
            this.setState({ disableCreateButton: true });
            let obj = {
                targetStudyProgramId: this.state.targetStudyProgram,
                sourceStudentStudyProgramId: this.state.student.studentStudyProgramId,
                applicationDate: this.state.date,
                committeeId: this.state.committee,
                phoneNumber: this.state.phoneNumber,
                email: this.state.email,
                targetStudyTypeId: this.state.studyType,
                facultyId: this.state.student.facultyId
            };
            axios.post('/equivalence/from-unsa', obj)
                .then(() => {
                    this.setState({ disableCreateButton: false });
                    this.clearForm();
                    toast('Uspješno ste dodali kandidata!');
                })
                .catch(err => {
                    this.setState({ disableCreateButton: false });
                    toast('Dodavanje kandidata nije uspjelo!');
                });
        }
    }

    render() {
        return (

            <div>
                <Segment clearing vertical>
                    <Divider horizontal>
                        <Header as="h4">
                            Osnovni podaci
                        </Header>
                    </Divider>
                    <Grid columns={2}>
                        <Grid.Column>

                            <Form>

                                <Form.Group >
                                    <Form.Field required error={this.state.jmbgErr} width={16}>
                                        <label>
                                            JMBG studenta
                                        </label>
                                        <input
                                            required
                                            fluid
                                            placeholder="JMBG"
                                            control={Input}
                                            value={this.state.jmbg}
                                            name="jmbg"
                                            onChange={(e) => this.setState({ jmbg: e.target.value })}
                                        />
                                    </Form.Field>

                                    <Form.Field>
                                        <label>
                                            <br />
                                        </label>
                                        <Button disabled={this.state.disableSearchButton} basic color="blue" fluid onClick={this.findStudentByJmbg} width={12}>Traži</Button>

                                    </Form.Field>
                                </Form.Group>

                                <Form.Field
                                    required
                                    error={this.state.studentErr}
                                >
                                    <label>
                                        Student
                                    </label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite studenta"
                                        value={this.state.student}
                                        onChange={this.handleInputChange}
                                        name="student"
                                        options={this.state.studentOptions}
                                        search
                                        disabled={this.state.disableStudentField}
                                        fluid
                                        selection

                                    />
                                </Form.Field>
                                <Form.Field required error={this.state.phoneNumberErr}>
                                    <label>
                                        Broj telefona
                                    </label>
                                    <input
                                        required
                                        fluid
                                        placeholder="Broj telefona"
                                        control={Input}
                                        value={this.state.phoneNumber}
                                        name="phoneNumber"
                                        onChange={(e) => this.setState({ phoneNumber: e.target.value })}
                                    />
                                </Form.Field>
                                <Form.Field required error={this.state.emailErr}>
                                    <label>
                                        Email
                                    </label>
                                    <input
                                        required
                                        fluid
                                        id="form-input-control-error-email"
                                        placeholder="Email"
                                        control={Input}
                                        value={this.state.email}
                                        name="email"
                                        onChange={(e) => this.setState({ email: e.target.value })}
                                    />
                                </Form.Field>


                            </Form>


                        </Grid.Column>
                        <Grid.Column>

                            <Form>


                                <Form.Field
                                    required
                                    error={this.state.targetStudyProgramErr}
                                >
                                    <label>
                                        Studijski program na koji se prebacuje
                                    </label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite studijski program"
                                        value={this.state.targetStudyProgram}
                                        onChange={this.handleInputChange}
                                        name="targetStudyProgram"
                                        options={this.state.targetStudyProgramOptions.filter((e) => (e.additional !== 'archived'))}
                                        search
                                        fluid
                                        selection

                                    />
                                </Form.Field>
                                <Form.Field
                                    required
                                    error={this.state.studyTypeErr}
                                >
                                    <label>
                                        Tip studiranja
                                    </label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite tip"
                                        value={this.state.studyType}
                                        onChange={this.handleInputChange}
                                        name="studyType"
                                        options={this.state.studyTypeOptions}
                                        search
                                        fluid
                                        selection

                                    />
                                </Form.Field>

                                <Form.Field
                                    required
                                    control={DateTimePicker}
                                    label="Datum podnošenja zahtjeva "
                                    format="D. M. YYYY."
                                    value={this.state.date}
                                    time={false}
                                    onChange={this.handleDateChange.bind(null, 'date')}
                                    style={{ borderWidth: '0px' }}
                                    error={this.state.dateErr}
                                />

                                <Form.Field
                                    required
                                    error={this.state.committeeErr}
                                >
                                    <label>
                                        Komisija
                                    </label>
                                    {/* eslint-disable-next-line react/jsx-no-undef */}
                                    <Dropdown
                                        selection
                                        name="committee"
                                        value={this.state.committee}
                                        options={this.state.committeeOptions}
                                        placeholder="Odaberite komisiju"
                                        onChange={this.handleInputChange}
                                        clearable
                                    >
                                        <Dropdown.Menu >
                                            {
                                                this.state.committeeOptions.map((el, index) =>
                                                    (<Popup
                                                        trigger={<Dropdown.Item text={el.text} value={el.value} name="committee" onClick={this.handleInputChange} />}
                                                        content={el.committeeMembers.map(e => (<div>{e.firstName + ' ' + e.lastName}</div>))}
                                                        hideOnScroll
                                                        position="left center"
                                                    />))
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Form.Field>


                            </Form>


                        </Grid.Column>


                    </Grid>
                    <br />
                    <Loader active={this.state.disableCreateButton} />
                    <Button
                        basic
                        color="blue"
                        disabled={this.state.disableCreateButton}
                        floated="right"
                        onClick={() => this.props.closeForm()}
                    >
                        Odustani

                    </Button>
                    <Button primary color="blue" disabled={this.state.disableCreateButton} onClick={this.createCandidate} floated="right">
                        Kreiraj

                    </Button>


                    <ToastContainer hideProgressBar />
                </Segment>


            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Candidates/CreateCandidates/CreateCandidatesFromUNSA.js